"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _types = require("./types");

var getFeatures = function getFeatures(payload) {
  return {
    type: _types.GET_FEATURES,
    payload: payload
  };
};

var getFeaturesSuccess = function getFeaturesSuccess(data) {
  return {
    type: _types.GET_FEATURES_SUCCESS,
    payload: data
  };
};

var getFeaturesError = function getFeaturesError(error) {
  return {
    type: _types.GET_FEATURES_ERROR,
    payload: {
      error: error
    }
  };
};

var _default = {
  getFeatures: getFeatures,
  getFeaturesSuccess: getFeaturesSuccess,
  getFeaturesError: getFeaturesError
};
exports["default"] = _default;
//# sourceMappingURL=actions.js.map